import React, { useState, useEffect, Fragment } from 'react';
import { showTemporaryMessage } from "../components/Message";
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';

import PickUser from '../components/PickUser';
import UserDetails from '../components/UserDetails';

const UserAdmin = () => {
	const { userType, loginToken, userId } = React.useContext(AuthContext);
	const { t } = useTranslation();

	const [selectedUserId, setSelectedUserId] = useState(0);
	// Dummy value to trigger a refresh of the list of users
	// The list of users must be refreshed when a user us renamed or deleted
	const [refreshUserListTrigger, setRefreshUserListTrigger] = useState(0);

	/**
	 * REGULAR and PRINTER users can only administer credentials relating to
	 * their own User ID, so we choose this ID for them.
	 */
//	useEffect(() => {
//		if(userType === 'REGULAR' || userType === 'PRINTER') {
//			setSelectedUserId(userId);
//		}
//	}, []);

	const refreshUserList = () => {
		setRefreshUserListTrigger(prev => prev + 1);
	};

	return (
		<div className="flex-grow min-w-full">
			{/* Heading */}
			<div className="super-admin w-full bg-light-blue shadow mb-10">
				<div className="max-w-screen-xl mx-auto py-4 px-4 text-center sm:text-start">
					<h1 className="text-4xl font-extrabold text-black">{t("page_user_admin")}</h1>
				</div>
			</div>
			<div className="max-w-screen-xl mx-auto px-6">
				{/* Dashboard content */}
				<div className="flex flex-col md:flex-row w-full justify-between gap-5 px-4 py-6 sm:px-0">
					<div className="w-full max-w-1/2">
						<div className="w-full items-top">
							<PickUser
								loginToken={loginToken}
								setSelectedUserId={setSelectedUserId}
								refreshUserListTrigger={refreshUserListTrigger} />
						</div>
					</div>
					<div className="w-full max-w-1/2">
						<div className="w-full items-top">
							{ selectedUserId != 0 && <UserDetails
								loginToken={loginToken}
								loggedInUserId={userId}
								loggedInUserType={userType}
								selectedUserId={selectedUserId}
								refreshUserList={refreshUserList} /> 
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserAdmin;
